import { render, staticRenderFns } from "./upsertLabel.vue?vue&type=template&id=7799c294&scoped=true&lang=pug"
import script from "./upsertLabel.vue?vue&type=script&lang=js"
export * from "./upsertLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7799c294",
  null
  
)

export default component.exports